<template>
  <div class="upload-finish-container col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-3">
    <div class="row">
      <div class="content col-xs-12 col-md-9" :class="classObject">
        <div class="row">
          <div class="col-xs-12 col-sm-7 upload__text">
            <slot name="stats" />
          </div>
          <div class="col-xs-12 col-sm-5">
            <step-publish-button
                :is-button-disabled="isButtonDisabled || showLoading"
                @publish="publish">
              {{ buttonMessage }}
              <template slot="icon">
                <slot name="icon" />
              </template>
            </step-publish-button>
            <error-popup :message="$store.state.errors.ratelimit" v-if="$store.state.errors.ratelimit" :top-offset="-48" />
            <error-popup :message="$store.state.errors.overquota" v-if="$store.state.errors.overquota" :top-offset="-17" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepPublishButton from './StepPublishButton'
import ErrorPopup from '../ui/ErrorPopup'

export default {
  name: 'FileList',
  components: {
    StepPublishButton,
    ErrorPopup,
  },
  props: {
    classObject: {
      type: Object,
      required: false,
    },
    isButtonDisabled: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    postUrl: {
      type: String,
      required: false,
    },
    redirectUrl: {
      type: String,
      required: false,
    },
    emitCustom: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      state: this.$store.state,
      errors: {},
      showLoading: false,
    }
  },
  computed: {
    buttonMessage() {
      return !this.showLoading ? this.buttonText : this.$t('stepPublish.buttonMessage')
    }
  },
  methods: {
    publish() {
      if (this.emitCustom) {
        this.$emit("publish-custom")
        return false;
      }

      if (!this.postUrl) {
        if (this.redirectUrl == '/') {
          window.location = this.redirectUrl
        }
        else {
          this.$router.push(this.redirectUrl)
        }
        return false;
      }

      var ids = []
      var names = []

      for (var i = 0; i < this.$store.state.files.length; i++) {
          ids.push(this.$store.state.files[i].id)
          names.push(this.$store.state.files[i].name)
      }

      var prejemniki = []
      for (var i = 0; i < this.$store.state.recipients.length; i++) {
        let gsm = this.$store.state.recipients[i].recipientPasswordGSM ? this.$store.state.recipients[i].recipientPasswordGSM : this.$store.state.recipients[i].recipientPasswordEmail
          prejemniki.push({
            id: this.$store.state.recipients[i].id,
            email: this.$store.state.recipients[i].recipientEmail,
            gsm: gsm,
          });
      }

      let legacyDate = this.$store.state.date.toISOString().split('T')[0].split('-')
      legacyDate = legacyDate[2] + "." + legacyDate[1] + "." + legacyDate[0]

      let packet = {
          ids: ids,
          imena: names,
          opis: this.$store.state.message,
          comment: this.$store.state.comment,
          url: this.$store.state.url,
          datum: legacyDate,
          date: this.$store.state.date.getTime(),
          notify: this.$store.state.notify,
          enc: this.$store.state.encrypt,
          sendpw: this.$store.state.sendPw,
          kontrolnaVsota: "testnaKontrolnaVsota",
          prejemniki: prejemniki,
          lang: this.$store.state.emailLang
      };

      this.showLoading = true

      this.$http.post(this.postUrl, packet, {
        credentials: true
      }).then(response => {
        this.showLoading = false

        if (response.bodyText !== "{}") {
          this.$store.setErrors({})
          if (response.body.url) {
            this.errors.url = response.body.url
          }
          if (response.body.datum) {
            this.errors.datum = response.body.datum
          }
          if (response.body.opis) {
            this.errors.opis = response.body.opis
          }
          if (response.body.prejemniki) {
            this.errors.prejemniki = response.body.prejemniki
          }
          if (response.body.ratelimit) {
            this.errors.ratelimit = response.body.ratelimit
          }
          if (response.body.overquota) {
            this.errors.overquota = response.body.overquota
          }
          this.$store.setErrors(this.errors)
        }
        else {
          this.$router.push(this.redirectUrl)
        }
      }, response => {
        this.showLoading = false
      })
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/sass/abstracts/variables_shared.scss";

.upload-finish-container {
  margin-top: 14px;
}

.content {
  border-radius: 2px;
  box-shadow: $box-shadow;
  padding: 18px;
}

.upload {
  &__text {
    font-size: 13px;
    font-weight: 600;
    line-height: 2.6;

    @media (max-width: 768px) {
      text-align: center;
      margin-bottom: 9px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/step/StepPublish.vue